import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/traffic/')({
  component: RouteComponent,
})

// TODO: Chưa implement - Trang quản lý lưu lượng truy cập
function RouteComponent() {
  return <div>Hello "/_authenticated/traffic/"!</div>
}
